import { vgField } from '../../channeldef';
import { DEFAULT_SORT_OP, isSortField } from '../../sort';
import { facetSortFieldName } from '../facet';
import { JoinAggregateTransformNode } from './joinaggregate';
export function makeJoinAggregateFromFacet(parent, facet) {
  var row = facet.row,
    column = facet.column;
  if (row && column) {
    var newParent = null;
    // only need to make one for crossed facet
    for (var _i = 0, _arr = [row, column]; _i < _arr.length; _i++) {
      var fieldDef = _arr[_i];
      if (isSortField(fieldDef.sort)) {
        var _fieldDef$sort = fieldDef.sort,
          field = _fieldDef$sort.field,
          _fieldDef$sort$op = _fieldDef$sort.op,
          op = _fieldDef$sort$op === void 0 ? DEFAULT_SORT_OP : _fieldDef$sort$op;
        parent = newParent = new JoinAggregateTransformNode(parent, {
          joinaggregate: [{
            op: op,
            field: field,
            as: facetSortFieldName(fieldDef, fieldDef.sort, {
              forAs: true
            })
          }],
          groupby: [vgField(fieldDef)]
        });
      }
    }
    return newParent;
  }
  return null;
}